import type { RegisteredServices } from '@/core/container/types'

export interface PaymentVeriffIdentityFormData {
  firstName: string
  lastName: string
}

export const userAdminsTable = 'userAdminsTable' as RegisteredServices
